import { Button } from 'theme-ui';

import { Svg } from '@snippets';

import { themed } from './Slider.theme';

export const NavigationButton = themed(
  ({
    theme,
    customCss,
    src = '/svgs/arrow-left.svg#arrow-left',
    alt = 'Previous Review',
    isNext = false,
    inactive,
    ...props
  }) => {
    return (
      <Button
        data-comp={NavigationButton.displayName}
        disabled={inactive}
        {...props}
        variant="buttons.plain"
        sx={{
          ...(isNext ? theme.buttonNext : theme.buttonPrev),
          opacity: inactive ? 0.5 : 1,
          ...props.sx,
        }}
      >
        <Svg
          alt={alt}
          src={src}
          viewBox="0 0 24 24"
          draggable={false}
          sx={theme.icon}
        />
      </Button>
    );
  }
);

NavigationButton.displayName = 'NavigationButton';
